import { useQuery } from '@tanstack/react-query';

import { COMPLETE_DINER_LOGIN_ENDPOINT } from 'reservations/base/constants/endpoints';
import { buildBentoboxApiEndpoint } from 'reservations/base/helpers/buildBentoboxApiEndpoint';
import { DinerLoginResponse } from 'reservations/dinerAccount/queries/getCurrentUser';
import { type RequestError, restClient } from 'utility/restClient';

type DinerLoginParams = {
  code: string;
  email: string;
};
export async function dinerLogin({ code, email }: Record<string, string>) {
  const endpoint = buildBentoboxApiEndpoint(COMPLETE_DINER_LOGIN_ENDPOINT);
  const response = await restClient.post(endpoint, {
    data: {
      email,
      code,
      is_booking_event: true
    }
  });

  try {
    return DinerLoginResponse.parse(response);
  } catch (err) {
    /* istanbul ignore next */
    throw err;
  }
}

export function useDinerLoginQuery({ code, email }: DinerLoginParams) {
  return useQuery<DinerLoginResponse, RequestError>({
    queryKey: ['dinerLogin', email, code],
    queryFn: () => dinerLogin({ code, email }),
    enabled: !!code && !!email,
    retry: false
  });
}
